// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

//
// Firebase/VueFire stuff
//
import Firebase from 'firebase'
import './firebaseConf'
import VueFire from 'VueFire'
Vue.use(VueFire)

//
// Firebase Auth stuff
//
let app;
Firebase.auth().onAuthStateChanged(function(user) {
  if (!app) {
    app = new Vue({
      el: '#app',
      template: '<App/>',
      components: { App },
      router
    })
  }
});

Vue.config.productionTip = false



// WEBPACK FOOTER //
// ./src/main.js